module.exports = __webpack_public_path__ + "img/expostyle_0904_sky_blue_pantone3015c.b81a6124.jpg";